import { render, staticRenderFns } from "./PageDisplay.vue?vue&type=template&id=8f15b178&"
import script from "./PageDisplay.vue?vue&type=script&lang=js&"
export * from "./PageDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports